import styled from 'styled-components';
import DetailCompletedSvg from '../../assets/mytrips/hotel-detail-completed.svg';

const DetailCompletedIcon = styled(DetailCompletedSvg as React.SFC<React.SVGProps<SVGSVGElement>>)`
  width: ${props => props.width || '46.6rem'};
  height: ${props => props.height || '16.1rem'};
  margin: ${props => props.margin};
  cursor: pointer;
`;

export default DetailCompletedIcon;
